import { render, staticRenderFns } from "./RecordsSummary.vue?vue&type=template&id=d0f59d8c&scoped=true"
import script from "./RecordsSummary.vue?vue&type=script&lang=ts"
export * from "./RecordsSummary.vue?vue&type=script&lang=ts"
import style0 from "./RecordsSummary.vue?vue&type=style&index=0&id=d0f59d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f59d8c",
  null
  
)

export default component.exports